import { exists } from '@/api'

export interface ReferenceUpdateImageRequest {
  referenceImageMasterId: number
}

export function ReferenceUpdateImageFromJSON(
  json: any
): ReferenceUpdateImageRequest {
  return ReferenceUpdateImageJSONTyped(json)
}

export function ReferenceUpdateImageJSONTyped(
  json: any
): ReferenceUpdateImageRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    referenceImageMasterId: exists(json, 'reference_image_master_id')
      ? json.reference_image_master_id
      : 0
  }
}

export function ReferenceUpdateImageToJSON(
  value?: ReferenceUpdateImageRequest | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    reference_image_master_id: value.referenceImageMasterId
  }
}
